import { ExperienceSource } from 'model/IExperience';
import req from 'utils/req';

type SuggestionsResponse = { suggestions: ExperienceSource[] };

export default {
  getById: async (
    id: string,
    lang: string,
    currency: string,
  ): Promise<ExperienceSource[]> => {
    const queryParams = new URLSearchParams({
      lang,
    });

    queryParams.set('currency', currency);

    try {
      const response = (await req(
        `${URL_API_HOST}/api/v3/experience/suggestions/${id}?${queryParams.toString()}`,
      ).get()) as SuggestionsResponse;

      return response?.suggestions ?? [];
    } catch (error) {
      console.error('Error fetching suggestions by ID:', error);
      return [];
    }
  },
};
